export default __webpack_public_path__ + "static/media/kp.19d8b871.jpg";